import React from 'react';
import { motion } from 'framer-motion';
export function TransitionBlock() {
  return <section className="bg-arena" data-id="element-415">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="bg-[#EFECE4] px-[24px] md:px-[80px] py-[48px] md:py-[64px] max-w-[640px] mx-auto" data-id="element-416">
        <p className="font-body text-[18px] text-carbon/70 leading-[1.7] mb-6" data-id="element-417">
          Después de analizar sitios web de empresas B2B en Colombia,
          encontramos siempre el mismo patrón: el problema era evidente pero
          nadie podía medirlo con precisión. Solo había opiniones de diseño.
        </p>
        <p className="font-body text-[18px] text-carbon/70 leading-[1.7] mb-6" data-id="element-418">
          No existía un número. No había criterios objetivos para saber si un
          sitio web estaba a la altura del negocio que representaba. La decisión
          de rediseñar dependía del gusto del diseñador, no de los datos del
          negocio.
        </p>
        <p className="font-body text-[18px] font-medium text-carbon leading-[1.7] mb-8" data-id="element-419">
          Por eso desarrollamos el ICD™.
          <br data-id="element-420" />
          Para que cada decisión sobre un sitio web tenga justificación
          objetiva, no preferencia visual.
        </p>
        <p className="font-body text-[13px] text-carbon/40 italic" data-id="element-421">
          — Equipo de Origen Studio
        </p>
      </motion.div>
    </section>;
}